<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-card flat>
                  <v-card-text>
                    <template>
                      <v-col cols="12">
                        <div>
                          <v-alert
                            border="bottom"
                            colored-border
                            type="warning"
                            elevation="2"
                          >
                            Para visualizar las imágenes de tipo celular, ingresar desde el mismo dispositivo.
                          </v-alert>
                        </div>
                      </v-col>
                    </template>
                    <template>
                        <template v-if="$vuetify.breakpoint.xsOnly">
                          <v-carousel :cycle="true" height="auto">
                            <template v-for="(item, i) in items">
                              <template v-if="item.type == 100 && item.status == 1">
                                <v-carousel-item :key="i">
                                  <v-img :src="item.image"></v-img>
                                </v-carousel-item>
                              </template>
                            </template>
                          </v-carousel>
                        </template>
                        <template v-else>
                          <v-carousel :cycle="true" height="auto" type="card">
                            <template v-for="(item, i) in items">
                              <template v-if="item.type == 1 && item.status == 1">
                                <v-carousel-item eager :key="i">
                                  <v-img max-height="700px" eager :src="item.image"></v-img>
                                </v-carousel-item>
                              </template>
                            </template>
                          </v-carousel>
                        </template>

                        <v-container fluid>
                          <v-row justify="center">
                            <v-col cols="12" lg="8" md="10" sm="12" xs="12" class="pt-8">
                              <v-row no-gutters align="center" justify="center">
                                <template v-if="$vuetify.breakpoint.xsOnly">
                                  <template v-for="body in bodyList">
                                    <template v-if="body.status == 1 && body.type == 100">
                                      <v-col cols="12" md="12" class="pt-8">
                                        <v-card class="pa-2 rounded" style="border: 0" outlined elevation="0" height="100%">
                                          <v-img eager :src="body.image"></v-img>
                                        </v-card>
                                      </v-col>
                                    </template>
                                  </template>
                                </template>
                                <template v-else>
                                  <template v-for="body in bodyList">
                                    <template v-if="body.status == 1 && body.type == 1">
                                      <v-col cols="12" md="12" class="pt-8">
                                        <v-card class="pa-2 rounded" style="border: 0" outlined elevation="0" height="100%">
                                          <v-img eager :src="body.image"></v-img>
                                        </v-card>
                                      </v-col>
                                    </template>
                                  </template>
                                </template>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>

                        <template v-for="groupRow in footerList">
                          <v-container fluid>
                            <v-row justify="center" align="center">
                              <v-col cols="12" lg="12" md="12" sm="12" xs="12">
                                <v-row no-gutters align="center" justify="center">
                                  <v-col cols="12" md="8">
                                    <template>
                                      <v-card
                                        class="elevation-10"
                                        color="primary"
                                        dark
                                      >
                                        <v-card-title class="text-h6 pa-2 ma-2">
                                          <b color="primary">{{ groupRow.title }}</b>
                                        </v-card-title>
                                      </v-card>
                                    </template>
                                  </v-col>
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="12" md="8" align="center" justify="center">
                                    <v-slide-group multiple show-arrows="always">
                                      <v-row justify="center" align="center" class="my-1">
                                        <v-slide-item v-for="body in groupRow.list" v-if="body.status == 1" :key="body.id" v-slot="{ active, toggle }">
                                          <v-card
                                            :color="active ? undefined : 'grey lighten-1'"
                                            class="ma-3"
                                            height="300"
                                            width="250"
                                            min-width="250"
                                            @click="toggle"
                                          >
                                            <v-img eager :src="body.image"></v-img>
                                          </v-card>
                                        </v-slide-item>
                                      </v-row>
                                    </v-slide-group>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-container>
                        </template>
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-dialog
                v-model="dialog"
                lg
              >
                <v-card>
                  <v-card-title class="primary dark">
                    <template>
                      <v-tabs
                          v-model="tab"
                          background-color="primary"
                          dark
                      >
                        <v-tab href="#tab-1">Imágenes Cabecera</v-tab>
                        <v-tab href="#tab-2">Imágenes Cuerpo</v-tab>
                        <v-tab href="#tab-3">Imágenes Pies</v-tab>
                      </v-tabs>
                    </template>
                  </v-card-title>

                  <v-card-text>
                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        key="1"
                        value="tab-1"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorImage" v-model="validProductColorImage">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="banner.group"
                                        :items="select.groups"
                                        item-value="id"
                                        item-text="name"
                                        label="Group"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="banner.type"
                                        :items="select.type"
                                        item-value="id"
                                        item-text="name"
                                        label="Tipo"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="banner.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="12"
                                    >
                                      <v-file-input
                                        v-model="imagesTmp"
                                        counter
                                        label="Seleccionar Imágenes"
                                        multiple
                                        :show-size="1000"
                                        :rules="[rules.required]"
                                        @change="imagesSelected(1)"
                                        dense
                                        outlined
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                            color="deep-purple accent-4"
                                            dark
                                            label
                                            small
                                          >
                                            {{ text }}
                                          </v-chip>
                                        </template>
                                      </v-file-input>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorImage || imagesTmp.length == 0"
                                        color="primary"
                                        block
                                        depressed
                                        @click="saveBanners()"
                                      >
                                        Registrar
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>

                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="bannerHeader"
                                    :items="items"
                                  >
                                    <template v-slot:item.showImage="{ item }">
                                      <v-row no-gutters>
                                        <v-img :src="item.image" width="70"></v-img>
                                      </v-row>
                                    </template>

                                    <template v-slot:item.type="{ item }">
                                      <template v-if="item.type == 1">MONITOR</template>
                                      <template v-else>CELULAR</template>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                        @click="updateStatus(1, item)"
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item
                        key="2"
                        value="tab-2"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorImage" v-model="validProductColorImage">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerBody.group"
                                        :items="select.groups"
                                        item-value="id"
                                        item-text="name"
                                        label="Group"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerBody.type"
                                        :items="select.type"
                                        item-value="id"
                                        item-text="name"
                                        label="Tipo"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerBody.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="12"
                                    >
                                      <v-file-input
                                        v-model="imagesTmpBody"
                                        counter
                                        label="Seleccionar Imágenes"
                                        multiple
                                        :show-size="1000"
                                        :rules="[rules.required]"
                                        @change="imagesSelected(2)"
                                        dense
                                        outlined
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                            color="deep-purple accent-4"
                                            dark
                                            label
                                            small
                                          >
                                            {{ text }}
                                          </v-chip>
                                        </template>
                                      </v-file-input>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorImage || imagesTmpBody.length == 0"
                                        color="primary"
                                        block
                                        depressed
                                        @click="saveBannersBody()"
                                      >
                                        Registrar
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>

                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="bannerBodyHeader"
                                    :items="bodyList"
                                  >
                                    <template v-slot:item.showImage="{ item }">
                                      <v-row no-gutters>
                                        <v-img :src="item.image" width="70"></v-img>
                                      </v-row>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                        @click="updateStatus(2, item)"
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item
                        key="3"
                        value="tab-3"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorImage" v-model="validProductColorImage">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerFooter.group"
                                        :items="select.products"
                                        item-value="name"
                                        item-text="name"
                                        label="Productos"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerFooter.title"
                                        label="Título"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerFooter.group_row"
                                        label="Grupo de Imágenes"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerFooter.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="12"
                                    >
                                      <v-file-input
                                        v-model="imagesTmpFooter"
                                        counter
                                        label="Seleccionar Imágenes"
                                        multiple
                                        :show-size="1000"
                                        :rules="[rules.required]"
                                        @change="imagesSelected(3)"
                                        dense
                                        outlined
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                            color="deep-purple accent-4"
                                            dark
                                            label
                                            small
                                          >
                                            {{ text }}
                                          </v-chip>
                                        </template>
                                      </v-file-input>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorImage || imagesTmpFooter.length == 0"
                                        color="primary"
                                        block
                                        depressed
                                        @click="saveBannersFooter()"
                                      >
                                        Registrar
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>

                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="bannerFooterHeader"
                                    :items="allRowFooter"
                                  >
                                    <template v-slot:item.showImage="{ item }">
                                      <v-row no-gutters>
                                        <v-img :src="item.image" width="70"></v-img>
                                      </v-row>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                        @click="updateStatus(3, item)"
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="adm_orange"
                      text
                      @click="dialog = false"
                    >
                      Cerrar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </v-row>
          </template>

          <v-btn
            fab
            bottom
            right
            color="primary"
            dark
            fixed
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import firebase from 'firebase'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  export default {
    name: 'HomeImage',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        dialog: false,
        tab: null,
        panel: [0],
        active: null,
        modal: false,
        search: '',
        validProductColorImage: true,
        rules: {
          required: v => !!v || 'Por favor completar este campo'
        },
        select: {
          products: [],
          groups: [
            { id: 'HOT WHEELS', name: 'HOT WHEELS' },
            { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' },
            { id: 'MINECRAFT', name: 'MINECRAFT' },
            { id: 'JUEGOS DE MESA', name: 'JUEGOS DE MESA' },
            { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' },
            { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' },
            { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' },
            { id: 'BLAZE', name: 'BLAZE' },
            { id: 'SMASHERS', name: 'SMASHERS' },
            { id: 'MUÑECAS', name: 'MUÑECAS' },
            { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' },
            { id: 'NERF', name: 'NERF' },
            { id: 'PLAY DOH', name: 'PLAY DOH' },
            { id: 'SUPER MARIO', name: 'SUPER MARIO' },
            { id: 'PRINCESAS', name: 'PRINCESAS' },
            { id: 'FRIEND', name: 'FRIEND' },
            { id: 'MUNDO BEBE', name: 'MUNDO BEBE' },
            { id: 'DIDACTICOS', name: 'DIDACTICOS' },
            { id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS', name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS' },
            { id: 'ÚTILES', name: 'ÚTILES' },
            { id: 'PELUCHES INTERACTIVOS', name: 'PELUCHES INTERACTIVOS' },
            { id: 'MAQUILLAJE', name: 'MAQUILLAJE' },
            { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' },
            { id: 'NAVIDAD', name: 'NAVIDAD' },
            { id: 'BLUEY', name: 'BLUEY' }
          ],
          type: [
            { id: '1', name: 'TAMAÑO COMPUTADORA' },
            { id: '100', name: 'TAMAÑO CELULAR' },
          ],
          status: [
            { id: 1, name: 'ACTIVO' },
            { id: 2, name: 'INACTIVO' }
          ]
        },
        banner: {
          id: null,
          group: null,
          images: [],
          type: null,
          status: null
        },
        bannerHeader: [
          { text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false },
          { text: 'GRUPO', value: 'group' },
          { text: 'ORDEN', value: 'order' },
          { text: 'TIPO', value: 'type' },
          { text: 'ESTADO', value: 'status' },
        ],
        bannerBodyHeader: [
          { text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false },
          { text: 'GRUPO', value: 'group' },
          { text: 'ORDEN', value: 'order' },
          { text: 'ESTADO', value: 'status' },
        ],
        bannerFooterHeader: [
          { text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false },
          { text: 'GRUPO', value: 'group' },
          { text: 'TITULO', value: 'title' },
          { text: 'ORDEN', value: 'order' },
          { text: 'GRUPO DE IMÁGENES', value: 'group_row' },
          { text: 'ESTADO', value: 'status' },
        ],
        bannerBody: {
          id: null,
          group: null,
          images: [],
          type: null,
          status: null
        },
        bannerFooter: {
          id: null,
          group: null,
          title: null,
          group_row: null,
          images: [],
          status: null
        },
        imagesTmp: [],
        imagesTmpBody: [],
        imagesTmpFooter: [],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
        // ************ preview  ************
        device: 1,
        items: [],
        bodyList: [],
        footerList: [],
        allRowFooter: [],
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getColorOrTextStatus(status, type) {
        let value = '';

        if (type === 'color') {
          value = status == 1 ? 'green' : 'red';
        } else if (type === 'text') {
          value = status == 1 ? 'ACTIVO' : 'INACTIVO';
        }

        return value;
      },

      getProducts () {
        axios.get('/secure/products')
        .then(response => {
          this.select.products = response.data;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      saveBanners() {
        this.overlay = true;

        const request = {
          id: this.banner.id,
          group: this.banner.group,
          type: this.banner.type,
          images: JSON.stringify(this.banner.images),
          status: this.banner.status
        }

        axios.post(process.env.DINO.PATH.SAVE_BANNER_HEADER, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.onUpload();
        })
        .then(() => {
          this.$refs.formProductColorImage.reset();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
          this.getBanners();
        });
      },

      saveBannersBody() {
        this.overlay = true;

        const request = {
          id: this.bannerBody.id,
          group: this.bannerBody.group,
          type: this.bannerBody.type,
          images: JSON.stringify(this.bannerBody.images),
          status: this.bannerBody.status
        }

        axios.post(process.env.DINO.PATH.SAVE_BANNER_BODY, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.onUpload();
        })
        .then(() => {
          this.$refs.formProductColorImage.reset();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
          this.getBanners();
        });
      },

      saveBannersFooter() {
        this.overlay = true;

        const request = {
          id: this.bannerFooter.id,
          group: this.bannerFooter.group,
          title: this.bannerFooter.title,
          group_row: this.bannerFooter.group_row,
          images: JSON.stringify(this.bannerFooter.images),
          status: this.bannerFooter.status
        }

        axios.post(process.env.DINO.PATH.SAVE_BANNER_FOOTER, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.onUpload();
        })
        .then(() => {
          this.$refs.formProductColorImage.reset();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
          this.getBanners();
        });
      },

      onUpload() {
        const storage = firebase.storage();
        const metadata = {
          cacheControl: "public, max-age=31536000"
        };

        if (this.tab == 'tab-1') {
          this.imagesTmp.map((file, index) => {
            let task = storage.ref(`/img/banners/${file.name}`).put(file, metadata);
          });
        } else if (this.tab == 'tab-2') {
          this.imagesTmpBody.map((file, index) => {
            let task = storage.ref(`/img/banners-body/${file.name}`).put(file, metadata);
          });
        } else if (this.tab == 'tab-3') {
          this.imagesTmpFooter.map((file, index) => {
            let task = storage.ref(`/img/banners-footer/${file.name}`).put(file, metadata);
          });
        }
      },

      imagesSelected(type) {
        const domain = 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img';
        let img = [];

        if (type == 1) {
          this.imagesTmp.map((file, index) => {
            let order = index + 1;

            let image = encodeURIComponent(`/banners/${file.name}`);
            image = domain.concat(`${image}?alt=media`);
            img.push({ image: image, order: order, name: file.name});
          });

          this.banner.images = img;
        } else if (type == 2) {
          this.imagesTmpBody.map((file, index) => {
            let order = index + 1;

            let image = encodeURIComponent(`/banners-body/${file.name}`);
            image = domain.concat(`${image}?alt=media`);
            img.push({ image: image, order: order, name: file.name});
          });

          this.bannerBody.images = img;
        } else if (type == 3) {
          this.imagesTmpFooter.map((file, index) => {
            let order = index + 1;

            let image = encodeURIComponent(`/banners-footer/${file.name}`);
            image = domain.concat(`${image}?alt=media`);
            img.push({ image: image, order: order, name: file.name});
          });

          this.bannerFooter.images = img;
        }
      },

      getBanners() {
        axios.get(process.env.DINO.PATH.GET_BANNERS)
        .then(response => {
          this.items = response.data.header;
          this.bodyList = response.data.body;
          this.footerList = response.data.footer;
          this.allRowFooter = response.data.allRowFooter;
        });
      },

      updateStatus(type, item) {
        const request = {
          type: type,
          id: item.id,
          status: item.status == 1 ? 0 : 1
        }

        axios.post(process.env.DINO.PATH.UPDATE_BANNER_STATUS, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.getBanners();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
      },
    },
    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getBanners();
      this.getProducts();
    },
    watch: {
      dialog (val) {
        if (val === false) {
          this.active = null;
          this.tab = 'tab-1';
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/manage/HomeImage.vue